module.exports = __webpack_public_path__ + "img/744.664d8c9c.jpg";